<template>
  <div>

    <head>
      <meta charset="utf-8" />
      <link rel="shortcut icon" type="image/png" :href="this.GetAgatrsFaviconUrl()" />
    </head>

    <a href="#main_content" class="skip-to-content-link">SKIP NAVIGATION</a>
    <center>
      <div class="bg-unclassified-green white">
        <b>UNCLASSIFIED - FOR OFFICIAL USE ONLY</b>
      </div>
    </center>
    <base-nav v-model="showMenu" class="navbar top-navbar" type="green" :transparent="false">
      <router-link slot="brand" class="navbar-brand" to="/">
        AGATR<img id="agatrs_s" :src="this.GetAgatrsFaviconUrl()" alt="'s' that looks like an aligator."
          class="AGATRS-Brand" />
      </router-link>

      <ul v-if="isLoggedIn" class="navbar-nav">
        <li class="nav-item active">
          <router-link to="/Dashboard" class="nav-link">
            <i class="tim-icons icon-planet"></i> Dashboard
            <span class="sr-only">(current)</span>
          </router-link>
        </li>
        <base-dropdown v-if="!isPartnerAccount" tag="li" :menu-on-right="!$rtl.isRTL" title-tag="a" class="nav-item"
          title-classes="nav-link" menu-classes="dropdown-navbar" tabindex="0">
          <template slot="title">
            <i class="tim-icons icon-chart-pie-36"></i> Reports
            <i class="caret d-none d-lg-block d-xl-block navbar-toggle-icon less-left-margin"></i>
          </template>

          <div class="nav-item-title">MAIN</div>
          <li class="nav-link">
            <router-link to="/CreateReport" class="nav-item dropdown-item">
              <span>
                <i class="tim-icons icon-simple-add"></i> Create Report
              </span>
            </router-link>
          </li>
          <li class="nav-link" style="padding-left: 10px !important">
            <router-link to="/overduereport" class="nav-item dropdown-item">
              <span>
                <i class="tim-icons icon-single-copy-04"></i> ACSA Overdue Reports
              </span>
            </router-link>
          </li>
         <li class="nav-link">
            <router-link to="/reports/countrysummary" class="nav-item dropdown-item btn-link">
              <span class="font-weight-normal">
                <i class="tim-icons icon-single-copy-04"></i> Country Summary
        </span>
        </router-link>
          </li> 
          <li class="nav-link">
            <organizational-report-modal>
              <template  v-slot:modal-link>
                <span class="font-weight-normal">
                <i class="tim-icons icon-single-copy-04"></i> Organizational Report
              </span>
              </template>
            </organizational-report-modal>
          </li>
          <br/>
          <div class="nav-item-title">FMR</div>
          <li class="nav-link">
            <router-link to="/reports/creditreports" class="nav-item dropdown-item">
              <span>
                <i class="tim-icons icon-chart-bar-32"></i> FMR-14R Credits Report
              </span>
            </router-link> 
          </li>
          <li class="nav-link">
            <router-link to="/reports/FMRReport" class="nav-item dropdown-item">
              <span>
                <i class="tim-icons icon-chart-bar-32"></i> FMR-14R Liabilities Report
              </span>
            </router-link>
          </li>
          <li class="nav-link">
            <router-link to="/reports/requestedauthorization" class="nav-item dropdown-item">
              <span>
                <i class="tim-icons icon-chart-bar-32"></i> FMR-14R Requested Authorization Report
              </span>
            </router-link>
          </li>
        </base-dropdown>
        
      </ul>
       
          
      <ul v-if="(isSponsor )" class="navbar-nav">
        <!-- ADMIN -->
        <!-- User Dropdown -->
        <base-dropdown tag="li" :menu-on-right="!$rtl.isRTL" title-tag="a" class="nav-item" title-classes="nav-link"
          menu-classes="dropdown-navbar" tabindex="0">
          <template slot="title">
            <i class="tim-icons icon-atom"></i> {{ isSponsor ? "Admin" : "Resources" }}
            <i class="caret d-none d-lg-block d-xl-block navbar-toggle-icon less-left-margin"></i>
          </template>

          <li v-if="isSponsor" class="nav-link">
            <router-link to="/admin/users" class="nav-item dropdown-item">Users</router-link>
          </li>
          <li v-if="isSponsor" class="nav-link">
            <router-link to="/admin/transactions" class="nav-item dropdown-item">Transactions</router-link>
          </li>
          <li class="nav-link">
            <router-link v-if="isLoggedIn && !isSponsor" :to="{ name: 'ViewAcsas' }" class="nav-item dropdown-item">
              ACSA/IA</router-link>
            <router-link v-if="isLoggedIn && isSponsor" :to="{ name: 'AdminACSAsDashboard' }"
              class="nav-item dropdown-item">View ACSAs / IAs</router-link>
            <router-link v-if="isLoggedIn && isOUSD" to="/admin/users" class="nav-item dropdown-item">
              Users
            </router-link>
          </li>
          <li v-if="isSponsor" class="nav-link">
            <router-link to="/admin/organizations" class="nav-item dropdown-item">Organizations</router-link>
          </li>
          <li v-if="isSponsor" class="nav-link">
            <router-link to="/admin/theaters" class="nav-item dropdown-item">Operation / Theater</router-link>
          </li>
          <li v-if="isSponsor" class="nav-link">
            <router-link to="/Admin/FinanceOffices" class="nav-item dropdown-item">Finance Offices</router-link>
          </li>
          <li v-if="isSponsor" class="nav-link">
            <router-link to="/Admin/BankingOffices" class="nav-item dropdown-item">Banking Offices</router-link>
          </li>
          <li v-if="isSponsor" class="nav-link">
            <a href="https://qlik.advana.data.mil/hub/stream/4012f26a-6a2b-4233-8757-15646a614418" target="_blank" class="nav-item dropdown-item">ACSA  ADVANA Dashboard</a>
          </li>
        </base-dropdown>
      </ul>

      <ul v-else-if="isLoggedIn && !isPartnerAccount" class="navbar-nav">
        <!-- ADMIN -->
        <!-- User Dropdown -->
        <base-dropdown tag="li" :menu-on-right="!$rtl.isRTL" title-tag="a" class="nav-item" title-classes="nav-link"
          menu-classes="dropdown-navbar" tabindex="0">
          <template slot="title">
            <i class="tim-icons icon-atom"></i> Resources
            <i class="caret d-none d-lg-block d-xl-block navbar-toggle-icon less-left-margin"></i>
          </template>
          <li  class="nav-link">
            <router-link v-if="isLoggedIn && !isSponsor"
              :to="{ name: 'ViewAcsas' }"
              class="nav-item dropdown-item"
              >View ACSAs / IAs</router-link
            >
            <router-link v-if="isLoggedIn && isOUSD" to="/admin/users" class="nav-item dropdown-item">
              Users
            </router-link>
          </li>
          <li class="nav-link">
            <a href="https://qlik.advana.data.mil/hub/stream/4012f26a-6a2b-4233-8757-15646a614418" target="_blank" class="nav-item dropdown-item">ACSA  ADVANA Dashboard</a>
          </li>
        </base-dropdown>
      </ul>
      

      <ul v-if="isLoggedIn" class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">

        <!-- Search -->
        <li v-if="isSuperAdmin && !isPartnerAccount" class="navbar-nav"> 

        <!-- <li v-if="isSponsor && !isPartnerAccount" class="navbar-nav"> -->

        <base-dropdown tag="li" :menu-on-right="!$rtl.isRTL" title-tag="a" class="nav-item" title-classes="nav-link"
          menu-classes="dropdown-navbar" tabindex="0">
          <template slot="title">
            <i style="color: green" class="tim-icons icon-atom"></i> 
          </template>
          <li class="nav-link">
            <router-link to="/admin/user-modifications" class="nav-item dropdown-item">User Modifications</router-link>
          </li>
          <li class="nav-link">
            <router-link to="/admin/superadminorder" class="nav-item dropdown-item">Order Modifications</router-link>
          </li>
          <li class="nav-link">
            <router-link to="/admin/orderReassignment" class="nav-item dropdown-item">Order Reassignment</router-link>
          </li>
          <li class="nav-link">
            <router-link to="/secret/faqs" class="nav-item dropdown-item">FAQs</router-link>
          </li>
          <li class="nav-link">
            <router-link to="/secret/email-extensions" class="nav-item dropdown-item">Email Extensions</router-link>
          </li>
          <li class="nav-link">
            <router-link to="/secret/hierarchy" class="nav-item dropdown-item">Organization Hierarchy</router-link>
          </li>
          <li  v-if="isSponsor" class="nav-link">
            <router-link
              to="/Admin/ToolTip"
              class="nav-item dropdown-item"
              >Manage Tool Tips</router-link
            >
          </li>
          <li  v-if="isSponsor" class="nav-link">
            <router-link
              to="/Admin/PartnerNation"
              class="nav-item dropdown-item"
              >Partner Nation</router-link
            >
          </li>
          <li v-if="!isPartnerAccount" class="nav-item">
            <div @click="toggleEditable" class="nav-link">
              <i class="tim-icons icon-light-3"></i>{{editable ? 'Disable Edit' : 'Edit ToolTips' }}
              <span class="sr-only">(current)</span>
            </div>
          </li>
          <li v-if="!isPartnerAccount" class="nav-link">
            <a href="https://qlik.advana.data.mil/hub/stream/4012f26a-6a2b-4233-8757-15646a614418" target="_blank" class="nav-item dropdown-item">ACSA  ADVANA Dashboard</a>
          </li>
        </base-dropdown>
      </li>
        <li v-if="!isPartnerAccount" class="nav-item">
          <router-link to="/Search" class="nav-link">
            <i class="tim-icons icon-zoom-split"></i> Search
            <span class="sr-only">(current)</span>
          </router-link>
        </li>
        <!-- FAQs -->
        <li v-if="isLoggedIn && !isPartnerAccount" class="nav-item">
          <router-link to="/FAQs" class="nav-link">
            <i class="tim-icons icon-light-3"></i> FAQs
          </router-link>
        </li>

        <!-- User Dropdown -->
        <base-dropdown tag="li" :menu-on-right="!$rtl.isRTL" title-tag="a" class="nav-item" title-classes="nav-link"
          menu-classes="dropdown-navbar" tabindex="0">
          <template slot="title">
            <i class="tim-icons icon-settings"></i> Settings
            <i class="caret d-none d-lg-block d-xl-block navbar-toggle-icon less-left-margin"></i>
          </template>
          <li class="nav-link">
            <router-link to="/Account/UserProfile" class="nav-item dropdown-item">
              <span> <i class="tim-icons icon-single-02"></i> Profile </span>
            </router-link>
          </li>
          <li class="nav-link">
            <router-link to="/Notifications" class="nav-item dropdown-item">
              <i class="tim-icons icon-bell-55"></i> Notifications
            </router-link>
          </li>
          <div class="dropdown-divider"></div>
          <li class="nav-link">
            <button class="nav-item dropdown-item btn-link" @click="logout">
              <i class="tim-icons icon-button-power"></i> Logout
            </button>
          </li>
        </base-dropdown>
      </ul>

      <ul v-if="!isLoggedIn" class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
        <!-- FAQs -->
        <li v-if="isLoggedIn && !isPartnerAccount" >
          <router-link to="/FAQs" class="nav-link">
            <i class="tim-icons icon-light-3"></i> FAQs
          </router-link>
        </li>
        <!-- Login -->
        <li>
          <router-link type="button" to="/Login" class="nav-link">
            <i class="tim-icons icon-single-02"></i> Login
          </router-link>
        </li>
        <!-- Register -->
        <li>
          <router-link type="button" to="/Register" class="nav-link">
            <i class="tim-icons icon-paper"></i> Register
          </router-link>
        </li>
      </ul>
      <div id="main_content"></div>
    </base-nav>
  </div>
</template>

<script>
import axios from "@/axios";
import Utility from "@/mixins/utility/utility";
import LoadingAlertMixin from "@/mixins/docLoadingAlert";
import Util from "@/util/util";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import { CollapseTransition } from "vue2-transitions";
import { BaseNav, Modal } from "@/components";
import CountrySummaryModal from "@/components/App/report/country/CountrySummaryModal.vue";
import OrganizationalReportModal from "@/components/App/report/organization/OrganizationalReportModal.vue";

export default {
  mixins: [Utility, LoadingAlertMixin],
  components: {
    CollapseTransition,
    BaseNav,
    Modal,
    CountrySummaryModal,
    OrganizationalReportModal
  },
  watch: {
    isLoggedIn(newValue, oldValue) {
      if (newValue) {
        this.getUser();
        this.getJointStaffOrganizations();
      }
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "authentication/isLoggedIn",
      isSponsor: "authentication/isSponsor",
      isSuperAdmin: "authentication/isSuperAdmin",
      isPartnerAccount: "authentication/isPartnerAccount",
      isOUSD: "authentication/isOUSD",
      jointStaffOrganizations: "organization/jointStaffOrganizations",
      editable: "tooltip/editable"
    }),
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    isRTL() {
      return this.$rtl.isRTL;
    },

  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: "",
      id: null
    };
  },
  methods: {
    ...mapActions({ 
      getJointStaffOrganizations: "organization/getJointStaffOrganizations", 
      toggleEditable: 'tooltip/editableValue',
      clearSearchCriteria: "orders/clearSearchCriteria",
    
      
    }),

    async logout() {
     this.$store.commit('orders/RESET_SEARCH_VALUES')
      await this.$store.dispatch("clearAllLogoutData");
    },
    validateOrganization(organizationId) {
      let ctx = this;
      let result = null;

      for (let organization of ctx.jointStaffOrganizations) {
        result = this.dfs(organization, organizationId);
        if (result) {
          break;
        }
      }

      return result.id || 48;
    },
    async generateReport(url, title) {
      let ctx = this;

      this.excelLoadTime += 1;

      this.showLoadingSweetAlert('Your Excel document is loading.<br><br>This message will update automatically.');

      axios({
        url: url,
        method: "GET",
        responseType: "blob", // important
      })
      .then((response) => {
        Util.fileDownload(response.data, title);
        ctx.excelLoadTime = 0;
        ctx.closeLoadingAlert();
      })
      .catch((error) => {
        ctx.excelLoadTime = 0;
        ctx.closeLoadingAlert();
      });

      await new Promise(r => setTimeout(r, 2000));

      if (this.excelLoadTime != 0) {
        this.updateLoadingMessage('Your Excel document is loading.<br><br>This message will disappear automatically in 10 seconds.');
      }

      while (this.excelLoadTime != 0) {
        await new Promise(r => setTimeout(r, 10000));
        if (this.excelLoadTime != 0) {
          this.updateLoadingMessage('Please hang tight. Your Excel document is <i>still loading</i>.<br><br><b>Note: <br>Depending on how many orders you export, it could take anywhere from a few seconds to over 5 minutes.');
        }
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    GetAgatrsFaviconUrl() {
      const _host = window.location.host;
      const _base = process.env.BASE_URL;
      return (
        window.location.protocol + "//" + _host + _base + "img/AGATRS Logo.png"
      );
    },
    async getUser() {
      let ctx = this;
      await this.getJointStaffOrganizations().then((res) => {
        ctx.axios.get(`api/applicationusers/email`).then((response) => {
          //Load the data
          ctx.user = response.data;
          ctx.user.organizationId = ctx.validateOrganization(
            ctx.user.organizationId

          );
          this.id = response.data.id
        });
      });
    },
    dfs(obj, targetId) {
      if (obj.id === targetId) {
        return obj;
      }

      if (obj.children) {
        for (let children of obj.children) {
          let check = this.dfs(children, targetId);
          if (check) {
            return check;
          }
        }
      }
      return null;
    },

  },
};
</script>

<style scoped>
.top-navbar {
  top: 0px;
}

.nav-item-title {
  padding: 0.25rem 1.5rem;
  font-weight: 600;
  font-size: 11px;
  color: #9A9A9A;
}

.nav-item-title-space {
  margin-top: 2rem;
}

/* Changes background color of dropdown items */
.dropdown-item.active {
  background-color: white;
}

.AGATRS-Brand {
  width: 25px;
  margin-left: -10px;
}

.skip-to-content-link {
  background: white;
  color: #275d34;
  height: 30px;
  left: 50%;
  padding: 8px;
  position: absolute;
  transform: translateY(-100%);
  transition: transform 0.3s;
}

.skip-to-content-link:focus {
  transform: translateY(0%);
  z-index: 1051;
}

@media only screen and (max-width: 768px) {
  .dropdown-item.active {
    background-color: #2dce89;
  }
}

.num {
  /* position: absolute;
    right: -6px;
    top: -15px; */
  color: white;
  background: red;
  border: 2px solid red;
  border-radius: 8px;
  font-size: 1.2em;
}

.dropdown-menu .tim-icons {
  opacity: 1;
}
.dropdown-menu .dropdown-item, .bootstrap-select .dropdown-menu.inner li a{
  padding-left: 10px;
}

</style>